var _circle, _rect, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "195px",
    height: "214px",
    viewBox: "0 0 195 214",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add_payment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "oval",
    fillOpacity: 0.15,
    fill: "#4DB6AC",
    cx: 101.166196,
    cy: 133.709135,
    r: 80.6219202
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "phone",
    stroke: "#565D6A",
    strokeWidth: 6,
    fill: "#F8F8FA",
    x: 57.4169735,
    y: 56.0872143,
    width: 87.0252925,
    height: 155.24384,
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.032949,16.0133487 C150.649698,16.0133487 139.287719,20.1715934 130.425024,26.8830164 C129.795554,27.3645498 129.660822,28.3755815 130.141817,29.005051 C130.623485,29.6345206 131.634516,29.769253 132.263851,29.2881237 C140.616314,22.9636521 151.325785,19.031623 163.034027,19.031623 C174.742269,19.031623 185.450932,22.9636521 193.804338,29.2881237 C194.433807,29.7697919 195.444704,29.6350595 195.926372,29.005051 C196.407906,28.3755815 196.273174,27.3645498 195.643165,26.8830164 C186.780336,20.1717282 175.417143,16.0133487 163.03524,16.0133487 L163.032949,16.0133487 Z",
    id: "Fill-1",
    fill: "#D1D3D4",
    transform: "translate(163.034290, 22.795718) rotate(30.000000) translate(-163.034290, -22.795718) "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.60085,28.6246594 C147.727512,28.6246594 139.453463,31.3104142 133.022688,36.499631 C132.313187,36.9570473 132.136418,38.0601011 132.666859,38.7163825 C133.197435,39.3726638 134.312615,39.4311376 134.908941,38.8337343 C140.752552,34.1186408 148.336367,31.6423947 156.60085,31.6423947 C164.865468,31.6423947 172.449552,34.1186408 178.29276,38.8337343 C178.889085,39.4311376 180.004265,39.3726638 180.534976,38.7163825 C181.065417,38.0601011 180.888109,36.9569126 180.179148,36.499631 C173.747833,31.3102795 165.474323,28.6246594 156.600985,28.6246594 L156.60085,28.6246594 Z",
    id: "Fill-4",
    fill: "#D1D3D4",
    transform: "translate(156.600842, 33.936079) rotate(30.000000) translate(-156.600842, -33.936079) "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.061461,45.4275114 C135.437785,45.9213055 135.319894,46.9379959 135.813553,47.5616719 C136.307213,48.185348 137.324038,48.3032388 137.947714,47.8090406 C141.327071,45.1312349 145.806383,43.6123971 150.585744,43.6123971 C155.365239,43.6123971 159.844417,45.1317739 163.223774,47.8090406 C163.84745,48.3032388 164.86441,48.185348 165.358069,47.5616719 C165.851728,46.9379959 165.733837,45.9211708 165.110161,45.4275114 C161.151186,42.2908074 156.004679,40.5939881 150.585878,40.5939881 C145.166808,40.5939881 140.020167,42.2908074 136.061461,45.4275114 Z",
    id: "Fill-6",
    fill: "#D1D3D4",
    transform: "translate(150.585811, 44.354839) rotate(30.000000) translate(-150.585811, -44.354839) "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.422852, 87.196411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6570282,4.80130542 L106.586249,4.80130542 C111.004527,4.80130542 114.586249,8.38302742 114.586249,12.8013054 L114.586249,66.420234 C114.586249,70.838512 111.004527,74.420234 106.586249,74.420234 L59.6570282,74.420234 L59.6570282,74.420234 L59.6570282,4.80130542 Z",
    id: "shadow",
    fillOpacity: 0.15,
    fill: "#707784"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "card",
    fill: "#A41B32",
    x: 0,
    y: 0,
    width: 108.898988,
    height: 69.6189286,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rec4",
    fill: "#D1D3D4",
    opacity: 0.5,
    x: 62.0065609,
    y: 51.2804184,
    width: 36.8100082,
    height: 2.8007615,
    rx: 1.40038075
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rec3",
    fill: "#D1D3D4",
    opacity: 0.5,
    x: 62.0065609,
    y: 45.2787866,
    width: 36.8100082,
    height: 2.8007615,
    rx: 1.40038075
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rec2",
    fill: "#FFFFFF",
    x: 71.6091717,
    y: 32.80899,
    width: 27.2073974,
    height: 5.60152299,
    rx: 2.8007615
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rec",
    fill: "#FFFFFF",
    x: 9.99241881,
    y: 32.80899,
    width: 52.0141421,
    height: 5.60152299,
    rx: 2.8007615
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stripe",
    fill: "#D1D3D4",
    x: 0,
    y: 11.6032244,
    width: 109,
    height: 12.8034811
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPayment);
export default __webpack_public_path__ + "static/media/add_payment.2938f914132fcd285d1eca25c0ac12a5.svg";
export { ForwardRef as ReactComponent };